export default "__VITE_ASSET__7dcfefa0__"